var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"master-detail fill-height",class:{ 'show-details': _vm.showDetails }},[_c('main',{staticClass:"fill-height",style:(_vm.mainStyle)},[_c('div',{staticClass:"scrollable"},[_vm._t("default")],2)]),_c('aside',{style:(_vm.asideStyle)},[_c('div',{staticClass:"scrollable"},[_vm._t("detail")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }